import DropDownChevron from '@assets/icons/dropdown-chevron.svg';
import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { Analytics } from '@/utils/analytics';
import { BORDER_RADIUS_SMALL } from '@/styles';
import { createStyles } from '@/contexts/theme-context';
import { DropdownMenu } from '@/components/dropdown-menu';
import { DropDownMenuOption } from '@/components/dropdown-menu-option';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { useNavigationConfirmationContext } from '@/contexts/navigation-confirmation-context';

interface SharePriceMenuOption {
  label: React.ReactNode;
  onPress: () => Promise<void>;
  trackingData: TrackingData;
}

interface SharePriceDropDownMenuProps {
  buttonTrackingData: TrackingData | null;
  menuOptions: SharePriceMenuOption[];
  salesRepMode: boolean;
}

export const SharePriceDropDownMenu: React.FC<SharePriceDropDownMenuProps> = ({
  buttonTrackingData,
  menuOptions,
  salesRepMode,
}) => {
  const [styles, theme] = useStyles();
  const { navigationBlocked } = useNavigationConfirmationContext();
  const [visible, setVisible] = useState(false);

  return (
    <DropdownMenu
      dropdownWidth={150}
      handleClose={() => setVisible(false)}
      handleOpen={() => setVisible(true)}
      hoverStyle={styles.hoverStyle}
      menuTitle={i18n.t('create_price_list')}
      rightElement={
        <DropDownChevron
          stroke={
            salesRepMode ? theme.sk.color.text.ondark : theme.colors.primary
          }
        />
      }
      size="large"
      style={[
        styles.orderButton,
        !salesRepMode ? styles.orderButtonDark : undefined,
      ]}
      textStyle={salesRepMode ? styles.orderTextDark : styles.orderText}
      trackingData={buttonTrackingData}
      visible={visible && !navigationBlocked}
    >
      {menuOptions.map((option, index) => (
        <DropDownMenuOption
          key={index}
          onSelect={async () => {
            await option.onPress();
            setVisible(false);

            Analytics.track(
              option.trackingData.name,
              option.trackingData.properties,
            );
          }}
        >
          {option.label}
        </DropDownMenuOption>
      ))}
    </DropdownMenu>
  );
};

const useStyles = createStyles((theme) => ({
  hoverStyle: {
    backgroundColor: theme.sk.color.bg.ondark.hover,
  },
  orderButton: {
    borderRadius: BORDER_RADIUS_SMALL,
    height: 40,
    marginRight: 4,
  },
  orderButtonDark: {
    backgroundColor: theme.colors.transparent,
    color: theme.sk.color.text.ondark,
  },
  orderText: {
    color: theme.colors.primary,
    textAlign: 'center',
  },
  orderTextDark: {
    color: theme.sk.color.text.ondark,
    textAlign: 'center',
  },
}));
